import React from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { setIsmodalOpen, setShowLevelModal } from "../home/cl_LoyalltyCoins";

export const LevelModal = () => {
  const { userDetails, userLoyalty } = useSelector((state) => state?.signIn);
  const dispatch = useDispatch();
  return (
    <div
      className="SB-modal SB-loyaltyLevel-modal SB-modal-fullscreen show"
      id="SB-loyaltyLevel-modal"
      aria-modal="true"
      role="dialog"
      style={{ display: "block" }}
    >
      <div className="SB-modal-dialog">
        <div className="SB-modal-content">
          <div
            className="SB-modal-close"
            data-dismiss="modal"
            onClick={() => {
              dispatch(setIsmodalOpen(false));
              dispatch(setShowLevelModal(false));
            }}
          >
            <div className="SB-iconSVG" title="close">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#${"icon-close"}`} />
              </svg>
            </div>
          </div>
          <div className="SB-modal-body">
            <div
              className="SB-loyaltyLevel-success"
              id="SB-loyaltyLevel-success"
            >
              {userLoyalty?.lifeTimeCoins <=
              LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                .levelCutoff ? (
                <>
                   <img
                    src={require('../../assets/images/loyalty/dash.webp')}
                    alt='dash'
                  />
                  <div className="SB-modal-header">
                    <div className="SB-modal-title">Congratulations</div>
                    <p>
                      You’ve reached{" "}
                      <span className="SB-loyaltyLevel-name">DASH</span>{" "}
                      level
                    </p>
                  </div>
                </>
              ) : userLoyalty?.lifeTimeCoins <=
                LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                  .levelCutoff ? (
                <>
                  <img
                    src={require('../../assets/images/loyalty/sprint.webp')}
                    alt='sprint'
                  />
                  <div className="SB-modal-header">
                    <div className="SB-modal-title">Congratulations</div>
                    <p>
                      You’ve reached{" "}
                      <span className="SB-loyaltyLevel-name">SPRINT</span> level
                    </p>
                  </div>
                </>
              ) : userLoyalty?.lifeTimeCoins <=
                LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                  .levelCutoff ? (
                <>
                 <img
                    src={require('../../assets/images/loyalty/surge.webp')}
                    alt='surge'
                  />
                  <div className="SB-modal-header">
                    <div className="SB-modal-title">Congratulations</div>
                    <p>
                      You’ve reached{" "}
                      <span className="SB-loyaltyLevel-name">SURGE</span> level
                    </p>
                  </div>
                </>
              ) : userLoyalty.level === "level3" ? (
                <>
                  <img
                    src={require('../../assets/images/loyalty/thrill.webp')}
                    alt='thrill'
                  />
                  <div className="SB-modal-header">
                    <div className="SB-modal-title">Congratulations</div>
                    <p>
                      You’ve reached{" "}
                      <span className="SB-loyaltyLevel-name">THRILL</span>{" "}
                      level
                    </p>
                  </div>
                </>
              ) : userLoyalty.level === "level4" ? (
                <>
                 <img
                    src={require('../../assets/images/loyalty/boss.webp')}
                    alt='boss'
                  />
                  <div className="SB-modal-header">
                    <div className="SB-modal-title">Congratulations</div>
                    <p>
                      You’ve reached{" "}
                      <span className="SB-loyaltyLevel-name">BOSS</span> level
                    </p>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="SB-confetti">
                <div className="SB-confetti-Before"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
